// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#bdpTimeline .card {
  box-shadow: none;
  background: none;
}
#bdpTimeline .tooltip-container {
  position: absolute;
  top: -2px;
  right: 20px;
  z-index: 2;
}
#bdpTimeline .tooltip-content {
  display: inline-block;
  background-color: #e1e6eb;
  color: #0a0a0a;
  padding: 5px 8px;
  border-radius: 4px;
  font-size: 12px;
}
#bdpTimeline .tooltip-content .tooltip-text {
  white-space: nowrap;
}
#bdpTimeline .completedJourney .border-color-active {
  border-right-color: #0080ff;
}
#bdpTimeline .completedJourney .active {
  color: #0080ff;
}
#bdpTimeline .completedJourney .bdp-first-active .bdp-primary-box::after {
  background-color: #0080ff;
  border: none;
  width: 14px;
  height: 14px;
  content: "";
  border-radius: 25px;
  position: absolute;
  top: 100%;
  left: -9px;
  float: right;
  transition: all 200ms ease-in;
}
#bdpTimeline .completedJourney .logistics {
  color: #0080ff;
}
#bdpTimeline .border-color-active {
  border-right-color: #0080ff;
}
#bdpTimeline .border-color-inactive {
  border-right-color: #a8a8a8;
}
#bdpTimeline .bdp-first-active .bdp-primary-box::after {
  background-color: #0080ff;
  border: none;
  width: 14px;
  height: 14px;
  content: "";
  border-radius: 25px;
  position: absolute;
  top: 100%;
  left: -9px;
  float: right;
  transition: all 200ms ease-in;
}
#bdpTimeline .inactive {
  float: right;
  margin: -17px;
  margin-right: -22px;
  top: 0;
  font-size: 14px;
  color: #a8a8a8;
}
#bdpTimeline .active {
  float: right;
  margin: -17px;
  margin-right: -22px;
  top: 0;
  font-size: 14px;
  color: #0080ff;
}
#bdpTimeline .left-timeline {
  float: right;
  margin-top: -20px;
  margin-right: 8px;
  text-align: right;
}
#bdpTimeline .right-timeline {
  margin-top: -20px;
  margin-left: 4px;
  text-align: left;
}
#bdpTimeline .box-height {
  height: 210px;
  position: relative;
}
#bdpTimeline .logistics {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: #0080ff;
  text-align: center;
}
#bdpTimeline .horizontal-timeline {
  padding: 30px;
  background: white;
  border-radius: 8px;
  position: relative;
  /* Line color based on completion status */
  /* Add these styles to your horizontal timeline CSS */
  /* Single horizontal line connecting all points */
}
#bdpTimeline .horizontal-timeline .border-color-active {
  background-color: #2d74ff;
  /* Active blue color */
}
#bdpTimeline .horizontal-timeline .horizontal-timeline {
  /* Existing styles */
  /* Modified point icon styles to match vertical timeline */
  /* Replace checkmark icons with circle styles */
  /* Connector line for horizontal timeline */
  /* Special handling for first point connector */
  /* Logistics start icon styling */
  /* Fix to ensure line doesn't extend before logistics */
}
#bdpTimeline .horizontal-timeline .horizontal-timeline .timeline-point .point-icon {
  position: relative;
  z-index: 2;
  background: white;
  padding: 5px;
}
#bdpTimeline .horizontal-timeline .horizontal-timeline .fa-circle-active {
  float: right;
  font-size: 14px;
  color: #0080ff; /* Active blue color */
  border-radius: 50%;
  width: 20px;
  height: 20px;
  background-color: #0080ff;
  display: flex;
  align-items: center;
  justify-content: center;
}
#bdpTimeline .horizontal-timeline .horizontal-timeline .fa-circle-inactive {
  float: right;
  font-size: 14px;
  color: #a8a8a8; /* Inactive gray color */
  border-radius: 50%;
  width: 20px;
  height: 20px;
  background-color: #a8a8a8;
  display: flex;
  align-items: center;
  justify-content: center;
}
#bdpTimeline .horizontal-timeline .horizontal-timeline .connector-line {
  position: absolute;
  left: -50%;
  width: 100%;
  top: 10px;
  height: 2px;
  z-index: 1;
}
#bdpTimeline .horizontal-timeline .horizontal-timeline .timeline-point:first-child .connector-line {
  width: 50%;
  left: 0;
}
#bdpTimeline .horizontal-timeline .horizontal-timeline .logistics-start {
  position: absolute;
  left: 43px;
  top: 47px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
}
#bdpTimeline .horizontal-timeline .horizontal-timeline .logistics-start .fa-circle-active {
  position: relative;
  z-index: 3;
}
#bdpTimeline .horizontal-timeline .horizontal-timeline .timeline-track::before {
  display: none;
}
#bdpTimeline .horizontal-timeline .border-color-inactive {
  background-color: #a8a8a8;
  /* Inactive gray color */
}
#bdpTimeline .horizontal-timeline .timeline-container {
  position: relative;
  padding: 20px 0;
}
#bdpTimeline .horizontal-timeline .transit-time-container {
  position: relative;
  display: flex;
  justify-content: center;
  padding-top: 10px;
}
#bdpTimeline .horizontal-timeline .transit-time-badge {
  background-color: #e1e6eb;
  padding: 5px 15px;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
  display: inline-block;
}
#bdpTimeline .horizontal-timeline .time-badge {
  display: none;
}
#bdpTimeline .horizontal-timeline .timeline-track {
  display: flex;
  position: relative;
  min-height: 120px;
  margin-top: 20px;
  padding-left: 100px;
}
#bdpTimeline .horizontal-timeline .timeline-track::before {
  content: "";
  position: absolute;
  left: 100px;
  right: 15px;
  top: 20px;
  height: 2px;
  background-color: #e1e6eb;
  /* Light gray line color */
  z-index: 0;
}
#bdpTimeline .horizontal-timeline .logistics-start {
  position: absolute;
  left: 43px;
  top: 47px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 4px;
  /* Custom checkmark for logistics start */
}
#bdpTimeline .horizontal-timeline .logistics-start .checkmark-icon {
  width: 20px;
  height: 20px;
  background-color: #2d74ff;
  /* Dark blue background */
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
#bdpTimeline .horizontal-timeline .logistics-start span {
  color: #2d74ff;
  font-weight: 600;
  font-size: 16px;
  margin-top: 10px;
}
#bdpTimeline .horizontal-timeline .timeline-point {
  flex: 1;
  position: relative;
  padding: 0 15px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* Replace circle with custom checkmark */
}
#bdpTimeline .horizontal-timeline .timeline-point .point-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
#bdpTimeline .horizontal-timeline .timeline-point .point-icon {
  position: absolute;
  top: 5px;
  /* Position to align with the line */
  z-index: 2;
  background: white;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* Style for inactive points */
}
#bdpTimeline .horizontal-timeline .timeline-point .point-icon .checkmark-icon {
  width: 20px;
  height: 20px;
  background-color: #2d74ff;
  /* Dark blue background */
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
#bdpTimeline .horizontal-timeline .timeline-point .point-icon .checkmark-iconn {
  width: 20px;
  height: 20px;
  background-color: #a8a8a8;
  /* Dark blue background */
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
#bdpTimeline .horizontal-timeline .timeline-point .point-icon .inactive-icon {
  width: 30px;
  height: 30px;
  background-color: #e1e6eb;
  /* Light gray for inactive */
  border-radius: 50%;
}
#bdpTimeline .horizontal-timeline .timeline-point .point-details {
  margin-top: 50px;
  /* Space below timeline */
  text-align: center;
  width: 100%;
}
#bdpTimeline .horizontal-timeline .timeline-point .timeline-font-header {
  margin-bottom: 5px;
  font-weight: 600;
  color: #333;
}
#bdpTimeline .horizontal-timeline .timeline-point .timeline-font-body {
  margin: 3px 0;
  font-size: 14px;
  color: #666;
}

/* Only add these styles - they should integrate with your existing CSS */
/* Fix for the timeline line to stop at last point */
.timeline-track {
  position: relative;
}

/* Override the existing line style */
.timeline-track::before {
  content: "";
  position: absolute;
  left: 100px;
  /* This will be set dynamically via JS */
  width: calc(100% - 150px);
  /* Default full width minus padding */
  top: 20px;
  height: 2px;
  background-color: #e1e6eb;
  z-index: 1;
}

/* Ensure checkmark appears in all completed circles */
.timeline-point.completed .point-icon i,
.timeline-point[class*=completed] .point-icon i {
  color: #2d74ff !important;
  border-color: #1a365d !important;
  background-color: #1a365d !important;
  position: relative;
}

/* Add checkmark using ::after */
.timeline-point.completed .point-icon i::after,
.timeline-point[class*=completed] .point-icon i::after {
  content: "\\f00c";
  /* Font Awesome checkmark */
  font-family: "Font Awesome 5 Free";
  color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 12px;
}

/* Style for the checkmark in logistics start */
.logistics-start i::after {
  content: "\\f00c";
  /* Font Awesome checkmark */
  font-family: "Font Awesome 5 Free";
  color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 12px;
}

/* Base timeline styles */
.horizontal-timeline {
  padding: 30px;
  background: white;
  border-radius: 8px;
  position: relative;
}

.timeline-container {
  position: relative;
  padding: 20px 0;
}

/* Remove the single continuous line */
.timeline-track::before {
  display: none;
}

/* Timeline track basic layout */
.timeline-track {
  display: flex;
  position: relative;
  min-height: 120px;
  margin-top: 20px;
  padding-left: 100px;
}

/* Logistics start styling */
.logistics-start {
  position: absolute;
  top: 20px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logistics-start i {
  font-size: 14px;
  color: #2d74ff;
  border: 2px solid #1a365d;
  border-radius: 50%;
  padding: 5px;
  position: relative;
}

.logistics-start i::after {
  content: "\\f00c";
  /* Font Awesome checkmark */
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 12px;
}

.logistics-start span {
  color: #2d74ff;
  font-weight: 600;
  font-size: 14px;
  margin-top: 10px;
}

/* Timeline point styling */
.timeline-point {
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Individual connector line */
.connector-line {
  position: absolute;
  left: -50%;
  width: 100%;
  top: 20px;
  height: 2px;
  z-index: 1;
}

/* Point icon styling */
.point-icon {
  position: relative;
  z-index: 2;
  background: white;
  display: inline-block;
  padding: 5px;
  margin-bottom: 15px;
}

.point-icon i {
  font-size: 14px;
  border-radius: 50%;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
}

/* Inactive circle */
.point-icon i.inactive {
  color: #a8a8a8;
  border: 2px solid #8c029b;
  background-color: rgb(196, 20, 20);
}

/* Active circle with checkmark */
.point-icon i.active {
  color: rgb(241, 10, 10);
  border: 2px solid #15c1ec;
  background-color: #25bfca;
  position: relative;
}

.point-icon i.active::after {
  content: "\\f00c";
  /* Font Awesome checkmark */
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  color: #2d74ff;
  position: absolute;
  font-size: 12px;
}

/* Point details positioning */
.point-details {
  margin-top: 30px;
  text-align: center;
  width: 100%;
}

/* First, make sure all potential lines before logistics are removed */
.timeline-track::before {
  display: none !important;
}

/* Adjust the logistics start icon position */
.logistics-start {
  position: absolute;
  left: 43px;
  top: 47px;
  z-index: 3;
  /* Increased z-index to ensure it's above any lines */
}

/* Create a visible break in any line that might appear before logistics */
.logistics-start::before {
  content: "";
  position: absolute;
  left: -20px;
  width: 40px;
  height: 10px;
  background-color: white;
  z-index: 2;
  top: 15px;
  /* Position to overlap the line */
}

/* Make sure the connector lines start from the point icons */
.connector-line {
  position: absolute;
  right: 50%;
  left: auto;
  /* Override any left positioning */
  width: 100%;
  /* Make the line stretch from this point to the next */
  top: 20px;
  height: 2px;
  z-index: 1;
}

.time-badge {
  position: absolute;
  top: -25px;
  left: 50%;
  transform: translateX(-50%);
  background: #e1e6eb;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
}

/* Special handling for the first point */
.timeline-point:first-child .connector-line {
  right: 50%;
  left: auto;
  width: 50%;
  /* Connect to the logistics icon */
}

/* Hide the last connector that would extend beyond the timeline */`, "",{"version":3,"sources":["webpack://./src/app/direct-link/direct-link-timeline/direct-link-timeline.component.scss"],"names":[],"mappings":"AAII;EACI,gBAAA;EACA,gBAAA;AAHR;AAmCI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AAjCR;AAoCI;EACI,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAlCR;AAoCQ;EACI,mBAAA;AAlCZ;AAuCQ;EACI,2BA5DG;AAuBf;AAwCQ;EACI,cAhEG;AA0Bf;AA0CY;EACI,yBArED;EAsEC,YAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,6BAAA;AAxChB;AA4CQ;EACI,cApFG;AA0Cf;AAyDI;EACI,2BApGO;AA6Cf;AA0DI;EACI,2BAvGS;AA+CjB;AAuEQ;EACI,yBAxHG;EAyHH,YAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,6BAAA;AArEZ;AAyEI;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,MAAA;EACA,eAAA;EACA,cA3IS;AAoEjB;AA0EI;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,MAAA;EACA,eAAA;EACA,cArJO;AA6Ef;AA2EI;EACI,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;AAzER;AA4EI;EACI,iBAAA;EACA,gBAAA;EACA,gBAAA;AA1ER;AA6EI;EACI,aAAA;EACA,kBAAA;AA3ER;AA+EI;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cA/KO;EAgLP,kBAAA;AA7ER;AAiFI;EACI,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EAEA,0CAAA;EAKR,qDAAA;EA0GQ,iDAAA;AA7LR;AA+EQ;EACI,yBAAA;EACA,sBAAA;AA7EZ;AAgFA;EACI,oBAAA;EAEA,0DAAA;EAQA,+CAAA;EA2BA,2CAAA;EAUA,+CAAA;EAMA,iCAAA;EAgBA,uDAAA;AA7IJ;AA2EI;EACI,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;AAzER;AA6EI;EACI,YAAA;EACA,eAAA;EACA,cAAA,EAAA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA3ER;AA8EI;EACI,YAAA;EACA,eAAA;EACA,cAAA,EAAA,wBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA5ER;AAgFI;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AA9ER;AAkFI;EACI,UAAA;EACA,OAAA;AAhFR;AAoFI;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAlFR;AAqFI;EACI,kBAAA;EACA,UAAA;AAnFR;AAuFI;EACI,aAAA;AArFR;AAwFQ;EACI,yBAAA;EACA,wBAAA;AAtFZ;AAyFQ;EACI,kBAAA;EACA,eAAA;AAvFZ;AA0FQ;EACI,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;AAxFZ;AA2FQ;EACI,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;AAzFZ;AA6FQ;EACI,aAAA;AA3FZ;AA8FQ;EACI,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AA5FZ;AA8FY;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,0BAAA;EACA,UAAA;AA5FhB;AAgGQ;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EAEA,yCAAA;AA/FZ;AAgGY;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA9FhB;AA6GY;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AA3GhB;AA+GQ;EACI,OAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EASA,yCAAA;AArHZ;AA8GY;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AA5GhB;AAgHY;EACI,kBAAA;EACA,QAAA;EACA,oCAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EA8CA,8BAAA;AA3JhB;AA+GgB;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA7GpB;AA2HgB;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAzHpB;AAwIgB;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,4BAAA;EACA,kBAAA;AAtIpB;AA0IY;EACI,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;AAxIhB;AA2IY;EACI,kBAAA;EACA,gBAAA;EACA,WAAA;AAzIhB;AA4IY;EACI,aAAA;EACA,eAAA;EACA,WAAA;AA1IhB;;AAiJA,yEAAA;AAEA,oDAAA;AACA;EACI,kBAAA;AA/IJ;;AAkJA,qCAAA;AACA;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,wCAAA;EACA,yBAAA;EACA,qCAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,UAAA;AA/IJ;;AAkJA,sDAAA;AACA;;EAEI,yBAAA;EACA,gCAAA;EACA,oCAAA;EACA,kBAAA;AA/IJ;;AAkJA,gCAAA;AACA;;EAEI,gBAAA;EACA,2BAAA;EACA,kCAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;AA/IJ;;AAkJA,+CAAA;AACA;EACI,gBAAA;EACA,2BAAA;EACA,kCAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;AA/IJ;;AAkJA,yBAAA;AACA;EACI,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AA/IJ;;AAkJA;EACI,kBAAA;EACA,eAAA;AA/IJ;;AAkJA,sCAAA;AACA;EACI,aAAA;AA/IJ;;AAkJA,gCAAA;AACA;EACI,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AA/IJ;;AAkJA,4BAAA;AACA;EACI,kBAAA;EAEA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAhJJ;;AAmJA;EACI,eAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AAhJJ;;AAmJA;EACI,gBAAA;EACA,2BAAA;EACA,kCAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;AAhJJ;;AAmJA;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAhJJ;;AAmJA,2BAAA;AACA;EACI,OAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAhJJ;;AAmJA,8BAAA;AACA;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AAhJJ;;AAqJA,uBAAA;AACA;EACI,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;AAlJJ;;AAqJA;EACI,eAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAlJJ;;AAqJA,oBAAA;AACA;EACI,cAAA;EACA,yBAAA;EACA,kCAAA;AAlJJ;;AAqJA,iCAAA;AACA;EACI,uBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;AAlJJ;;AAqJA;EACI,gBAAA;EACA,2BAAA;EACA,kCAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AAlJJ;;AAqJA,8BAAA;AACA;EACI,gBAAA;EACA,kBAAA;EACA,WAAA;AAlJJ;;AAqJA,sEAAA;AACA;EACI,wBAAA;AAlJJ;;AAqJA,6CAAA;AACA;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,qDAAA;AAlJJ;;AAqJA,0EAAA;AACA;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,iCAAA;AAlJJ;;AAqJA,6DAAA;AACA;EACI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,kCAAA;EACA,WAAA;EACA,sDAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AAlJJ;;AAqJA;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AAlJJ;;AAqJA,yCAAA;AACA;EACI,UAAA;EACA,UAAA;EACA,UAAA;EACA,kCAAA;AAlJJ;;AAqJA,kEAAA","sourcesContent":["$active-color: #0080ff;\n$inactive-color: #a8a8a8;\n\n#bdpTimeline {\n    .card {\n        box-shadow: none;\n        background: none;\n    }\n\n    // .tooltip-container {\n    //     position: relative;\n    //  //   text-align: right;\n    //     margin-top: -100px;\n    //   //  justify-content: flex-end;\n\n    // }\n\n    // .tooltip-content {\n    //     display: inline-block;\n    //     background-color: #e1e6eb;\n    //     color: #0a0a0a;\n    //     padding: 5px 8px;\n    //     border-radius: 4px;\n    //     font-size: 12px;\n    //     position: relative;\n    // }\n\n    // .tooltip-content::after {\n    //     content: '';\n    //     position: absolute;\n    //     top: 100%;\n    //     left: 50%;\n    //     margin-left: -5px;\n    //     border-width: 5px;\n    //     border-style: solid;\n    //     border-color: #333 transparent transparent transparent;\n    // }\n\n    .tooltip-container {\n        position: absolute;\n        top: -2px;\n        right: 20px;\n        z-index: 2;\n    }\n\n    .tooltip-content {\n        display: inline-block;\n        background-color: #e1e6eb;\n        color: #0a0a0a;\n        padding: 5px 8px;\n        border-radius: 4px;\n        font-size: 12px;\n\n        .tooltip-text {\n            white-space: nowrap;\n        }\n    }\n\n    .completedJourney {\n        .border-color-active {\n            border-right-color: $active-color;\n        }\n\n        .active {\n            color: $active-color;\n        }\n\n        .bdp-first-active {\n            .bdp-primary-box::after {\n                background-color: $active-color;\n                border: none;\n                width: 14px;\n                height: 14px;\n                content: \"\";\n                border-radius: 25px;\n                position: absolute;\n                top: 100%;\n                left: -9px;\n                float: right;\n                transition: all 200ms ease-in;\n            }\n        }\n\n        .logistics {\n            color: $active-color;\n        }\n\n        .bdp-circle-inactive+.bdp-circle-active {\n            .border-color-active {\n                .active {\n                    // border: 1px solid $active-color;\n                    // border-radius: 50%;\n                    // padding: 2px;\n                    // margin-right: -25px;\n                }\n            }\n        }\n    }\n\n    .border-color-active {\n        border-right-color: $active-color;\n    }\n\n    .border-color-inactive {\n        border-right-color: $inactive-color;\n    }\n\n    .bdp-circle-inactive+.bdp-circle-active {\n        .border-color-active {\n            .active {\n                // border: 1px solid $active-color;\n                // border-radius: 50%;\n                // padding: 2px;\n                // margin-right: -25px;\n            }\n        }\n    }\n\n    .bdp-first-active {\n        .bdp-primary-box::after {\n            background-color: $active-color;\n            border: none;\n            width: 14px;\n            height: 14px;\n            content: \"\";\n            border-radius: 25px;\n            position: absolute;\n            top: 100%;\n            left: -9px;\n            float: right;\n            transition: all 200ms ease-in;\n        }\n    }\n\n    .inactive {\n        float: right;\n        margin: -17px;\n        margin-right: -22px;\n        top: 0;\n        font-size: 14px;\n        color: $inactive-color;\n    }\n\n    .active {\n        float: right;\n        margin: -17px;\n        margin-right: -22px;\n        top: 0;\n        font-size: 14px;\n        color: $active-color;\n    }\n\n    .left-timeline {\n        float: right;\n        margin-top: -20px;\n        margin-right: 8px;\n        text-align: right;\n    }\n\n    .right-timeline {\n        margin-top: -20px;\n        margin-left: 4px;\n        text-align: left;\n    }\n\n    .box-height {\n        height: 210px;\n        position: relative;\n\n    }\n\n    .logistics {\n        font-size: 16px;\n        line-height: 24px;\n        font-weight: 600;\n        color: $active-color;\n        text-align: center;\n    }\n\n     \n    .horizontal-timeline {\n        padding: 30px;\n        background: white;\n        border-radius: 8px;\n        position: relative;\n\n        /* Line color based on completion status */\n        .border-color-active {\n            background-color: #2d74ff;\n            /* Active blue color */\n        }\n/* Add these styles to your horizontal timeline CSS */\n.horizontal-timeline {\n    /* Existing styles */\n    \n    /* Modified point icon styles to match vertical timeline */\n    .timeline-point .point-icon {\n        position: relative;\n        z-index: 2;\n        background: white;\n        padding: 5px;\n    }\n    \n    /* Replace checkmark icons with circle styles */\n    .fa-circle-active {\n        float: right;\n        font-size: 14px;\n        color: #0080ff; /* Active blue color */\n        border-radius: 50%;\n        width: 20px;\n        height: 20px;\n        background-color: #0080ff;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    \n    .fa-circle-inactive {\n        float: right;\n        font-size: 14px;\n        color: #a8a8a8; /* Inactive gray color */\n        border-radius: 50%;\n        width: 20px;\n        height: 20px;\n        background-color: #a8a8a8;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    \n    /* Connector line for horizontal timeline */\n    .connector-line {\n        position: absolute;\n        left: -50%;\n        width: 100%;\n        top: 10px;\n        height: 2px;\n        z-index: 1;\n    }\n    \n    /* Special handling for first point connector */\n    .timeline-point:first-child .connector-line {\n        width: 50%;\n        left: 0;\n    }\n    \n    /* Logistics start icon styling */\n    .logistics-start {\n        position: absolute;\n        left: 43px;\n        top: 47px;\n        z-index: 2;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    }\n    \n    .logistics-start .fa-circle-active {\n        position: relative;\n        z-index: 3;\n    }\n    \n    /* Fix to ensure line doesn't extend before logistics */\n    .timeline-track::before {\n        display: none;\n    }\n}\n        .border-color-inactive {\n            background-color: #a8a8a8;\n            /* Inactive gray color */\n        }\n\n        .timeline-container {\n            position: relative;\n            padding: 20px 0;\n        }\n\n        .transit-time-container {\n            position: relative;\n            display: flex;\n            justify-content: center;\n            padding-top: 10px;\n        }\n    \n        .transit-time-badge {\n            background-color: #e1e6eb;\n            padding: 5px 15px;\n            border-radius: 4px;\n            font-size: 14px;\n            color: #333;\n            display: inline-block;\n        }\n    \n        // Remove the old time badge styles or keep them for reference\n        .time-badge {\n            display: none; // Hide the old badges\n        }\n        /* Single horizontal line connecting all points */\n        .timeline-track {\n            display: flex;\n            position: relative;\n            min-height: 120px;\n            margin-top: 20px;\n            padding-left: 100px;\n\n            &::before {\n                content: '';\n                position: absolute;\n                left: 100px;\n                right: 15px;\n                top: 20px;\n                height: 2px;\n                background-color: #e1e6eb;\n                /* Light gray line color */\n                z-index: 0;\n            }\n        }\n\n        .logistics-start {\n            position: absolute;\n            left: 43px;\n            top: 47px;\n            z-index: 2;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            margin-top: 4px;\n\n            /* Custom checkmark for logistics start */\n            .checkmark-icon {\n                width: 20px;\n                height: 20px;\n                background-color: #2d74ff;\n                /* Dark blue background */\n                border-radius: 50%;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n\n                &::before {\n                    // content: '';\n                    // width: 12px;\n                    // height: 6px;\n                    // border-left: 2px solid white;\n                    // border-bottom: 2px solid white;\n                    // transform: rotate(-45deg);\n                    // position: relative;\n                    // top: -2px;\n                }\n            }\n            \n\n            span {\n                color: #2d74ff;\n                font-weight: 600;\n                font-size: 16px;\n                margin-top: 10px;\n            }\n        }\n\n        .timeline-point {\n            flex: 1;\n            position: relative;\n            padding: 0 15px;\n            text-align: center;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n\n            .point-content {\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n                width: 100%;\n            }\n\n            /* Replace circle with custom checkmark */\n            .point-icon {\n                position: absolute;\n                top: 5px;\n                /* Position to align with the line */\n                z-index: 2;\n                background: white;\n                padding: 5px;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n\n                .checkmark-icon {\n                    width: 20px;\n                    height: 20px;\n                    background-color: #2d74ff;\n                    /* Dark blue background */\n                    border-radius: 50%;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n\n                    &::before {\n                        // content: '';\n                        // width: 12px;\n                        // height: 6px;\n                        // border-left: 2px solid white;\n                        // border-bottom: 2px solid white;\n                        // transform: rotate(-45deg);\n                        // position: relative;\n                        // top: -2px;\n                    }\n                }\n\n                .checkmark-iconn {\n                    width: 20px;\n                    height: 20px;\n                    background-color:#a8a8a8;\n                    /* Dark blue background */\n                    border-radius: 50%;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n\n                    &::before {\n                        // content: '';\n                        // width: 12px;\n                        // height: 6px;\n                        // border-left: 2px solid white;\n                        // border-bottom: 2px solid white;\n                        // transform: rotate(-45deg);\n                        // position: relative;\n                        // top: -2px;\n                    }\n                }\n\n                /* Style for inactive points */\n                .inactive-icon {\n                    width: 30px;\n                    height: 30px;\n                    background-color: #e1e6eb;\n                    /* Light gray for inactive */\n                    border-radius: 50%;\n                }\n            }\n\n            .point-details {\n                margin-top: 50px;\n                /* Space below timeline */\n                text-align: center;\n                width: 100%;\n            }\n\n            .timeline-font-header {\n                margin-bottom: 5px;\n                font-weight: 600;\n                color: #333;\n            }\n\n            .timeline-font-body {\n                margin: 3px 0;\n                font-size: 14px;\n                color: #666;\n            }\n        }\n    }\n}\n\n\n/* Only add these styles - they should integrate with your existing CSS */\n\n/* Fix for the timeline line to stop at last point */\n.timeline-track {\n    position: relative;\n}\n\n/* Override the existing line style */\n.timeline-track::before {\n    content: '';\n    position: absolute;\n    left: 100px;\n    /* This will be set dynamically via JS */\n    width: calc(100% - 150px);\n    /* Default full width minus padding */\n    top: 20px;\n    height: 2px;\n    background-color: #e1e6eb;\n    z-index: 1;\n}\n\n/* Ensure checkmark appears in all completed circles */\n.timeline-point.completed .point-icon i,\n.timeline-point[class*=\"completed\"] .point-icon i {\n    color: #2d74ff !important;\n    border-color: #1a365d !important;\n    background-color: #1a365d !important;\n    position: relative;\n}\n\n/* Add checkmark using ::after */\n.timeline-point.completed .point-icon i::after,\n.timeline-point[class*=\"completed\"] .point-icon i::after {\n    content: '\\f00c';\n    /* Font Awesome checkmark */\n    font-family: 'Font Awesome 5 Free';\n    color: white;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    font-size: 12px;\n}\n\n/* Style for the checkmark in logistics start */\n.logistics-start i::after {\n    content: '\\f00c';\n    /* Font Awesome checkmark */\n    font-family: 'Font Awesome 5 Free';\n    color: white;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    font-size: 12px;\n}\n\n/* Base timeline styles */\n.horizontal-timeline {\n    padding: 30px;\n    background: white;\n    border-radius: 8px;\n    position: relative;\n}\n\n.timeline-container {\n    position: relative;\n    padding: 20px 0;\n}\n\n/* Remove the single continuous line */\n.timeline-track::before {\n    display: none;\n}\n\n/* Timeline track basic layout */\n.timeline-track {\n    display: flex;\n    position: relative;\n    min-height: 120px;\n    margin-top: 20px;\n    padding-left: 100px;\n}\n\n/* Logistics start styling */\n.logistics-start {\n    position: absolute;\n    // left: 30px;\n    top: 20px;\n    z-index: 2;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.logistics-start i {\n    font-size: 14px;\n    color: #2d74ff;\n    border: 2px solid #1a365d;\n    border-radius: 50%;\n    padding: 5px;\n    position: relative;\n}\n\n.logistics-start i::after {\n    content: '\\f00c';\n    /* Font Awesome checkmark */\n    font-family: 'Font Awesome 5 Free';\n    font-weight: 900;\n    color: white;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    font-size: 12px;\n}\n\n.logistics-start span {\n    color: #2d74ff;\n    font-weight: 600;\n    font-size: 14px;\n    margin-top: 10px;\n}\n\n/* Timeline point styling */\n.timeline-point {\n    flex: 1;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n/* Individual connector line */\n.connector-line {\n    position: absolute;\n    left: -50%;\n    width: 100%;\n    top: 20px;\n    height: 2px;\n    z-index: 1;\n}\n\n\n\n/* Point icon styling */\n.point-icon {\n    position: relative;\n    z-index: 2;\n    background: white;\n    display: inline-block;\n    padding: 5px;\n    margin-bottom: 15px;\n}\n\n.point-icon i {\n    font-size: 14px;\n    border-radius: 50%;\n    padding: 5px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    height: 30px;\n}\n\n/* Inactive circle */\n.point-icon i.inactive {\n    color: #a8a8a8;\n    border: 2px solid #8c029b;\n    background-color: rgb(196, 20, 20);\n}\n\n/* Active circle with checkmark */\n.point-icon i.active {\n    color: rgb(241, 10, 10);\n    border: 2px solid #15c1ec;\n    background-color: #25bfca;\n    position: relative;\n}\n\n.point-icon i.active::after {\n    content: '\\f00c';\n    /* Font Awesome checkmark */\n    font-family: 'Font Awesome 5 Free';\n    font-weight: 900;\n    color: #2d74ff;\n    position: absolute;\n    font-size: 12px;\n}\n\n/* Point details positioning */\n.point-details {\n    margin-top: 30px;\n    text-align: center;\n    width: 100%;\n}\n\n/* First, make sure all potential lines before logistics are removed */\n.timeline-track::before {\n    display: none !important;\n}\n\n/* Adjust the logistics start icon position */\n.logistics-start {\n    position: absolute;\n    left: 43px;\n    top: 47px;\n    z-index: 3;\n    /* Increased z-index to ensure it's above any lines */\n}\n\n/* Create a visible break in any line that might appear before logistics */\n.logistics-start::before {\n    content: '';\n    position: absolute;\n    left: -20px;\n    width: 40px;\n    height: 10px;\n    background-color: white;\n    z-index: 2;\n    top: 15px;\n    /* Position to overlap the line */\n}\n\n/* Make sure the connector lines start from the point icons */\n.connector-line {\n    position: absolute;\n    right: 50%;\n    left: auto;\n    /* Override any left positioning */\n    width: 100%;\n    /* Make the line stretch from this point to the next */\n    top: 20px;\n    height: 2px;\n    z-index: 1;\n}\n\n.time-badge {\n    position: absolute;\n    top: -25px;\n    left: 50%;\n    transform: translateX(-50%);\n    background: #e1e6eb;\n    padding: 3px 8px;\n    border-radius: 4px;\n    font-size: 12px;\n    white-space: nowrap;\n}\n\n/* Special handling for the first point */\n.timeline-point:first-child .connector-line {\n    right: 50%;\n    left: auto;\n    width: calc(50%);\n    /* Connect to the logistics icon */\n}\n\n/* Hide the last connector that would extend beyond the timeline */\n// .timeline-point:last-child .connector-line { \n//     display: none;\n// }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
